import { createContext, useContext, useMemo, useState } from 'react'
import { useUser } from '../auth'

const ProjectSelectionContext = createContext(null)

function AccountProjectSelection ({ children }) {
  const [selectedProjectIds, setSelectedProjectIds] = useState([])
  const selection = useMemo(() => [selectedProjectIds, setSelectedProjectIds], [selectedProjectIds])
  return <ProjectSelectionContext.Provider value={selection}>{children}</ProjectSelectionContext.Provider>
}

export function ProjectSelectionProvider ({ children }) {
  const user = useUser()
  const accountKey = user ? `${user.id || ''}:${user.email || ''}` : 'anonymous'
  return <AccountProjectSelection key={accountKey}>{children}</AccountProjectSelection>
}

export function useProjectSelection () {
  const sharedSelection = useContext(ProjectSelectionContext)
  const localSelection = useState([])
  return sharedSelection || localSelection
}
